export default __webpack_public_path__ + "static/media/whatworked.45df2cf0.png";